import React from 'react';
import './Ordinarypet.css';
import cavityImage from '../../../imgs/ordinarpet1.webp';

const Ordinarypet = () => {
    return (
        <div className="Ordinary-container">
            <div className='Ordinarys'>
                <h2 className="Ordinary-title">Compared with the ordinary PET special machines</h2>
                <div className="Ordinary-content">
                    <ul className="Ordinary-text">
                        <li>The high-speed PET special machines are faster, and the cycle time can be shortened by 3-5 seconds</li>
                        <li>More efficient, the production capacity can be increased by 30%-40%</li>
                        <li>More energy-saving, the production cost of each preform can be saved by about 0.00023 US dollars</li>
                    </ul>
                    <p className="Ordinary-text">Taking 13.5g 72 cavity water bottle preform as an example, the production cycle of an ordinary pet special machine (PET3105L-V6) is 17.2 seconds, and it can produce 15069 pieces preforms per hour.</p>
                    <p className="Ordinary-text">And the production cycle of the high-speed pet special machine (KPET3105L-E6) only takes 12.9 seconds and the number of preforms produced per hour is as high as 20,093 pieces.</p>
                </div>
                <div className="Ordinary">
                    <img src={cavityImage} alt="72 Cavity PET Preforms Machine" className="Cavity-image"/>
                </div>
            </div>

        </div>
    );
};

export default Ordinarypet;
